import { useMenuFooterCopy, useShowMenuLocaleSwitcher } from '@/context/site-chrome-copy'
import { getFooterLinks, type FooterLinkId } from '../../footer-links'
import MenuLocaleSwitcher from '../../menu-locale-switcher'

const FOOTER_LINK_ORDER: FooterLinkId[] = ['privacyPolicy', 'termsOfService', 'dmca', 'copyright', 'manageCookies']

const footerLinkClassName =
    'cursor-pointer border-none bg-transparent text-xs leading-4 font-semibold whitespace-nowrap text-white opacity-70 transition-opacity hover:opacity-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-giphyWhite'

const Footer = () => {
    const copy = useMenuFooterCopy()
    const footerLinks = getFooterLinks(copy)
    const showLocaleSwitcher = useShowMenuLocaleSwitcher()

    return (
        <footer className="flex w-full bg-[rgba(0,0,0,0.10)] px-8 py-3">
            <div className="ml-2 flex w-full min-w-0 items-center">
                <div className="mr-8 flex shrink-0 items-center justify-start text-xs leading-4 font-semibold text-white opacity-80">
                    {`© ${new Date().getFullYear()} GIPHY, Inc.`}
                </div>
                <div className="h-6 w-0.5 min-w-[2px] shrink-0 bg-white opacity-30" />
                <div className="ml-8 flex min-w-0 flex-1 items-center justify-start gap-5">
                    {FOOTER_LINK_ORDER.map((id) => {
                        const link = footerLinks[id]

                        return link.onClick ? (
                            <button key={id} type="button" onClick={link.onClick} className={footerLinkClassName}>
                                {link.label}
                            </button>
                        ) : (
                            <a key={id} href={link.href} className={footerLinkClassName}>
                                {link.label}
                            </a>
                        )
                    })}
                    {showLocaleSwitcher && (
                        <MenuLocaleSwitcher localeSwitcher={copy.localeSwitcher} className="ml-auto shrink-0" />
                    )}
                </div>
            </div>
        </footer>
    )
}

export default Footer
